import { useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "@/pages/home/components/Navbar";
import LegalDocument, { type LegalSection } from "@/components/feature/LegalDocument";
import QuoteModal from "@/components/feature/QuoteModal";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import LandingFooter from "@/components/feature/LandingFooter";
import LanguageTransitionWrapper from "@/components/feature/LanguageTransitionWrapper";

const termsSections: LegalSection[] = [
  { id: "aceptacion", titleKey: "legal.terms.s1.title", bodyKeys: ["legal.terms.s1.p1"] },
  { id: "objeto", titleKey: "legal.terms.s2.title", bodyKeys: ["legal.terms.s2.p1"] },
  { id: "uso", titleKey: "legal.terms.s3.title", bodyKeys: ["legal.terms.s3.p1", "legal.terms.s3.p2"] },
  { id: "propiedad", titleKey: "legal.terms.s4.title", bodyKeys: ["legal.terms.s4.p1", "legal.terms.s4.p2"] },
  { id: "servicios", titleKey: "legal.terms.s5.title", bodyKeys: ["legal.terms.s5.p1"] },
  { id: "responsabilidad", titleKey: "legal.terms.s6.title", bodyKeys: ["legal.terms.s6.p1", "legal.terms.s6.p2"] },
  { id: "enlaces", titleKey: "legal.terms.s7.title", bodyKeys: ["legal.terms.s7.p1"] },
  { id: "datos", titleKey: "legal.terms.s8.title", bodyKeys: ["legal.terms.s8.p1"] },
  { id: "modificaciones", titleKey: "legal.terms.s9.title", bodyKeys: ["legal.terms.s9.p1"] },
  { id: "ley", titleKey: "legal.terms.s10.title", bodyKeys: ["legal.terms.s10.p1", "legal.terms.s10.p2"] },
];

export default function TerminosPage() {
  const { t } = useTranslation("common");
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteService, setQuoteService] = useState<string | undefined>(undefined);

  const openQuote = (service?: string) => {
    setQuoteService(service);
    setQuoteOpen(true);
  };
  const closeQuote = () => {
    setQuoteOpen(false);
    setTimeout(() => setQuoteService(undefined), 300);
  };

  return (
    <div className="relative bg-background-950 min-h-screen">
      <Navbar onOpenQuote={openQuote} />

      <LanguageTransitionWrapper>
        <LegalDocument
          titleKey="legal.terms.title"
          subtitleKey="legal.terms.subtitle"
          updatedKey="legal.terms.updated"
          sections={termsSections}
          documentTitle="Términos y Condiciones | Openlab Secure"
          seeAlso={[{ to: "/politica-privacidad", labelKey: "legal.link.privacy", icon: "ri-shield-check-line" }]}
        />

        <LandingFooter pageName={t("legal.link.terms")} />
      </LanguageTransitionWrapper>

      <QuoteModal isOpen={quoteOpen} onClose={closeQuote} preselectedService={quoteService} />
      <WhatsAppFloat />
    </div>
  );
}